// extracted by mini-css-extract-plugin
module.exports = {"points":"styles_points__3AyYw","active":"styles_active__1rixx"};